// Import the functions you need from the SDKs you need
import {getAuth} from 'firebase/auth';
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCBevjQyF7_v6QcUr05sbWNt5HZStxS7S8",
  authDomain: "classadvisor-15685.firebaseapp.com",
  projectId: "classadvisor-15685",
  storageBucket: "classadvisor-15685.appspot.com",
  messagingSenderId: "814073374289",
  appId: "1:814073374289:web:17a37c937c7c4dc4757a70"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export  const auth = getAuth(app);